import React from "react";
import { useLocation } from "react-router-dom";

export function PageTransition({ children }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="animate-page-enter" data-testid="page-transition">
      {children}
    </div>
  );
}
